import { Formik, Form, FieldArray, Field, getIn } from "formik";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
// import Swal from "sweetalert2";

import Toggle from "react-toggle";
import FormInput from "../../../../components/FormInput";
import { validationSchema } from "./validation";
import Sidebar from "../../sidebar";
import FormSelect from "../../../../components/FormSelect";
import {
  addCustomers,
  getCountries,
  getCustomers,
  updateCustomers,
} from "./form-section.service";
import toast from "react-hot-toast";
import { AuthContext } from "../../../../contexts/AuthContext";

function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

const AddProduct = (props: any) => {
  const [company, setCompany] = useState<any>("");
  const [loading, setLoading] = useState(true);
  const { user } = useContext(AuthContext);

  const navigate = useNavigate();
  const { id } = useParams();

  const handleSubmit = (values: any, actions: any) => {
    if (props.isEdit && id) {
      updateCustomers(id, values)
        .then((response) => {
          toast.success("Customer updated successfully.");
          navigate("/admin/customers");
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        })
        .finally(() => {
          actions.setSubmitting(false);
        });
    } else {
      addCustomers(values)
        .then((response) => {
          toast.success("Customer added successfully.");
          navigate("/admin/customers");
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        })
        .finally(() => {
          actions.setSubmitting(false);
        });
    }
  };

  useEffect(() => {
    if (props.isEdit && id) {
      setLoading(true);
      getCustomers(id).then((response) => {
        setCompany(response.data);
        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  }, []);

  const isBackendUser = user?.userType === "Back end Entry User";
  const isSuperAdmin = user?.userType === "Super Admin";

  return (
    <section className="ec-page-content ec-vendor-dashboard section-space-p">
      <div className="container">
        <div className="row">
          <Sidebar />
          <div className="ec-shop-rightside col-lg-9 col-md-12">
            <div className="ec-vendor-dashboard-card space-bottom-30">
              <div className="ec-vendor-card-header">
                <h5>Add User</h5>
              </div>
              <div className="ec-vendor-card-body">
                {loading ? (
                  "Loading..."
                ) : (
                  <Formik
                    validationSchema={validationSchema}
                    initialValues={{
                      name: company ? company.name : "",
                      country: company ? company.country : "",
                      defaultSize: company
                        ? {
                            name: capitalizeFirstLetter(company.defaultSize),
                            id: company.defaultSize,
                          }
                        : { name: "Centimeter", id: "centimeter" },
                      // email: company ? company.email : "",
                      contactPerson: company ? company.contactPerson : "",
                      users: company
                        ? company.users.map((value: any) => {
                            return {
                              ...value,
                              password: "Qwerty@1234",
                              confirmPassword: "Qwerty@1234",
                              isPasswordChanged: false,
                            };
                          })
                        : [
                            {
                              firstName: "",
                              lastName: "",
                              username: "",
                              email: "",
                              password: "Qwerty@1234",
                              confirmPassword: "Qwerty@1234",
                              isPasswordChanged: false,
                              isActive: true,
                            },
                          ],
                    }}
                    onSubmit={handleSubmit}
                  >
                    {({
                      handleChange,
                      handleBlur,
                      errors,
                      values,
                      touched,
                      handleSubmit,
                      setFieldValue,
                    }) => (
                      <Form className="add_product_form">
                        <div className="row">
                          <div className="col-lg-6">
                            <FormInput
                              label="Company Name"
                              placeholder="Company Name"
                              name="name"
                              type="text"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.name}
                              error={getIn(errors, "name")}
                              touched={getIn(touched, "name")}
                              autoFocus
                              isRequired={false}
                              className={""}
                            />
                          </div>
                          <div className="col-lg-6">
                            <FormSelect
                              isAsync
                              margin="0"
                              label="Country"
                              placeholder="Country"
                              name="country"
                              getOptions={getCountries}
                              getOptionLabel={(option: { name: any }) =>
                                option.name
                              }
                              getOptionValue={(option: { id: any }) =>
                                option.id
                              }
                              onChange={(name: string, value: any) => {
                                setFieldValue(name, value);
                              }}
                              value={values.country}
                              error={getIn(errors, "country")}
                              touched={getIn(touched, "country")}
                            />
                          </div>
                          {/* <div className="col-lg-6">
                            <FormInput
                              label="Email"
                              placeholder="Email"
                              name="email"
                              type="text"
                              disabled={props.editing}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.email}
                              error={getIn(errors, "email")}
                              touched={getIn(touched, "email")}
                              isRequired={false}
                              className={""}
                            />
                          </div> */}
                          <div className="col-lg-6">
                            <FormInput
                              label="Contact Person"
                              placeholder="Contact Person"
                              name="contactPerson"
                              type="text"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.contactPerson}
                              error={getIn(errors, "contactPerson")}
                              touched={getIn(touched, "contactPerson")}
                              isRequired={false}
                              className={""}
                            />
                          </div>
                          <div className="col-lg-6">
                            <FormSelect
                              label="Default Size"
                              name="defaultSize"
                              options={[
                                { name: "Inch", id: "inch" },
                                { name: "Centimeter", id: "centimeter" },
                              ]}
                              placeholder="Default Size"
                              getOptionLabel={(option: { name: any }) =>
                                option.name
                              }
                              getOptionValue={(option: { id: any }) =>
                                option.id
                              }
                              onChange={(name: string, value: any) => {
                                setFieldValue(name, value);
                              }}
                              value={getIn(values, "defaultSize")}
                              error={getIn(errors, "defaultSize")}
                              touched={getIn(touched, "defaultSize")}
                            />
                          </div>

                          <FieldArray
                            name="users"
                            render={(arrayHelpers) => (
                              <div className="col-12">
                                {values.users && values.users.length > 0 ? (
                                  values.users.map(
                                    (friend: any, index: any) => (
                                      <div className="row" key={index}>
                                        <div className="col-12">
                                          <h3 className="p-0 mt-3">
                                            User {index + 1}
                                          </h3>
                                        </div>

                                        <div className="col-lg-6">
                                          <FormInput
                                            label="First Name"
                                            placeholder="First Name"
                                            name={`users[${index}].firstName`}
                                            type="text"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={
                                              values.users[index].firstName
                                            }
                                            error={getIn(
                                              errors,
                                              `users[${index}].firstName`
                                            )}
                                            touched={getIn(
                                              touched,
                                              `users[${index}].firstName`
                                            )}
                                            isRequired={false}
                                            className={""}
                                          />
                                        </div>
                                        <div className="col-lg-6">
                                          <FormInput
                                            label="Last Name"
                                            placeholder="Last Name"
                                            name={`users[${index}].lastName`}
                                            type="text"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.users[index].lastName}
                                            error={getIn(
                                              errors,
                                              `users[${index}].lastName`
                                            )}
                                            touched={getIn(
                                              touched,
                                              `users[${index}].lastName`
                                            )}
                                            isRequired={false}
                                            className={""}
                                          />
                                        </div>
                                        <div className="col-lg-6">
                                          <FormInput
                                            label="Email"
                                            placeholder="Email"
                                            name={`users[${index}].email`}
                                            type="text"
                                            disabled={!!values.users[index].id}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.users[index].email}
                                            error={getIn(
                                              errors,
                                              `users[${index}].email`
                                            )}
                                            touched={getIn(
                                              touched,
                                              `users[${index}].email`
                                            )}
                                            isRequired={false}
                                            className={""}
                                          />
                                        </div>
                                        <div className="col-lg-6">
                                          <FormInput
                                            label="Username"
                                            placeholder="Username"
                                            name={`users[${index}].username`}
                                            type="text"
                                            disabled={!!values.users[index].id}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.users[index].username}
                                            error={getIn(
                                              errors,
                                              `users[${index}].username`
                                            )}
                                            touched={getIn(
                                              touched,
                                              `users[${index}].username`
                                            )}
                                            isRequired={false}
                                            className={""}
                                          />
                                        </div>
                                        <div className="col-lg-6">
                                          <FormInput
                                            label="Password"
                                            placeholder="Password"
                                            name={`users[${index}].password`}
                                            type="password"
                                            disabled={
                                              !props.isEdit ||
                                              (!values.users[index]
                                                .isPasswordChanged &&
                                                !!values.users[index].id) ||
                                              values.users[index].isNew
                                            }
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.users[index].password}
                                            error={getIn(
                                              errors,
                                              `users[${index}].password`
                                            )}
                                            touched={getIn(
                                              touched,
                                              `users[${index}].password`
                                            )}
                                            isRequired={false}
                                            className={""}
                                          />
                                        </div>
                                        <div className="col-lg-6">
                                          <FormInput
                                            label="Confirm Password"
                                            placeholder="Confirm Password"
                                            name={`users[${index}].confirmPassword`}
                                            type="password"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            disabled={
                                              !props.isEdit ||
                                              (!values.users[index]
                                                .isPasswordChanged &&
                                                !!values.users[index].id) ||
                                              values.users[index].isNew
                                            }
                                            value={
                                              values.users[index]
                                                .confirmPassword
                                            }
                                            error={getIn(
                                              errors,
                                              `users[${index}].confirmPassword`
                                            )}
                                            touched={getIn(
                                              touched,
                                              `users[${index}].confirmPassword`
                                            )}
                                            isRequired={false}
                                            className={""}
                                          />
                                        </div>
                                        {props.isEdit &&
                                          !!values.users[index].id && (
                                            <div className="col-lg-2">
                                              <div className="default-form-box d-flex flex-column">
                                                <label>Password Change</label>
                                                <Toggle
                                                  name={`users.${index}.isPasswordChanged`}
                                                  defaultChecked={
                                                    values.users[index]
                                                      .isPasswordChanged
                                                  }
                                                  value={
                                                    values.users[index]
                                                      .isPasswordChanged
                                                  }
                                                  icons={false}
                                                  onChange={(event) => {
                                                    setFieldValue(
                                                      `users.${index}.isPasswordChanged`,
                                                      event.target.checked
                                                    );
                                                  }}
                                                />
                                              </div>
                                            </div>
                                          )}

                                        <div className="col-lg-1">
                                          <div className="default-form-box d-flex flex-column">
                                            <label>Status</label>
                                            <Toggle
                                              name={`users.${index}.isActive`}
                                              defaultChecked={
                                                values.users[index].isActive
                                              }
                                              value={
                                                values.users[index].isActive
                                              }
                                              icons={false}
                                              onChange={(event) => {
                                                setFieldValue(
                                                  `users.${index}.isActive`,
                                                  event.target.checked
                                                );
                                              }}
                                            />
                                          </div>
                                        </div>
                                        <div
                                          // style={{ marginTop: "20px" }}
                                          className="col-lg-12 d-flex align-items-start "
                                        >
                                          {(isSuperAdmin || isBackendUser) && (
                                            <div className="text-right w-100">
                                              <button
                                                className="btn btn-primary mr-1 mb-1"
                                                type="button"
                                                onClick={() =>
                                                  arrayHelpers.push({
                                                    firstName: "",
                                                    lastName: "",
                                                    username: "",
                                                    email: "",
                                                    password: "Qwerty@1234",
                                                    confirmPassword:
                                                      "Qwerty@1234",
                                                    isNew: true,
                                                    isActive: true,
                                                  })
                                                }
                                              >
                                                Add User
                                              </button>
                                              {values.users.length !== 1 && (
                                                <button
                                                  className="btn btn-primary mr-1 text-right"
                                                  type="button"
                                                  onClick={() =>
                                                    arrayHelpers.remove(index)
                                                  }
                                                >
                                                  Delete User
                                                </button>
                                              )}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    )
                                  )
                                ) : (
                                  <button
                                    // style={{ marginTop: "32px" }}
                                    className="btn btn-primary mr-1"
                                    type="button"
                                    onClick={() => arrayHelpers.push("")}
                                  >
                                    Add a User
                                  </button>
                                )}
                              </div>
                            )}
                          />
                          {(isSuperAdmin || isBackendUser) && (
                            <div className="col-lg-12">
                              <div className="text-right">
                                <button
                                  className="btn btn-primary mr-1"
                                  type="button"
                                  onClick={() => {
                                    handleSubmit();
                                  }}
                                >
                                  Save
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                      </Form>
                    )}
                  </Formik>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AddProduct;
